enum Type {
    CHAT = 1,
    BROWSER_UPGRADE = 3,
    NO_DOMAIN = 4,
    MAINTENANCE_MODE = 5,
    CONGRATS = 10,
    NOT_PUBLISHED = 11,
    GUIDANCE = 12,
    EMP = 14,
    XING_VOUCHERS = 16,
    WEB_COMPONENT_UPSELL = 18,
    EXTERNAL_WEBSITE_IMPORT_STARTED = 15,
    EXTERNAL_WEBSITE_IMPORT_SKIPPED = 17,
    EXTERNAL_WEBSITE_IMPORT_FINISHED = 19,
    SECTIONS_ADD_GROUP = 20,
    RANKING_COACH = 21,
    AVIARY_SHUTDOWN = 22
}

export default Type;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/definitions/Type.ts
 **/